import { type PreSignUpOption } from '@/karehero-app/auth/PreSignUp';
import { makeSceneLookup, type Scene } from '@/designs-dev/scenes';

// The two shapes of the opening, for the switch above the frame. Not states of
// one design: two designs of the same screen, which is what the select is for
// here, the way Project MC's takes sit behind one row.
//
// Kind 'view' rather than 'happy' for the same reason: neither is a state the
// prototype gets into, they are different answers to the same question.
export const introScenes: Scene<PreSignUpOption>[] = [
  {
    id: 'chat',
    label: 'Option one: chat style intro',
    kind: 'view',
    repro: 'Hello, then the question, answered in the chat',
    initial: 'chat',
  },
  {
    id: 'carousel',
    label: 'Option two: traditional carousel',
    kind: 'view',
    repro: 'Four slides that say what KareHero is, then in',
    initial: 'carousel',
  },
];

export const introSceneById = makeSceneLookup(introScenes);
